module.exports = __webpack_public_path__ + "img/nocode.dddb776e.png";